<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card :loading="loading">
              <v-card-title class="pb-5">
                <v-btn
                  @click="updatePack"
                  class="submit-btn"
                  :loading="loading"
                >
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  ذخیره
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      :rules="rules.title"
                      v-model="title"
                      :error-messages="errors !== undefined ? errors.title : ''"
                      label="عنوان"
                      required
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <price-input
                      :dense="true"
                      :label="'قیمت'"
                      :error="errors !== undefined ? errors.price : ''"
                      v-model="price"
                    ></price-input>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="expire"
                      :error-messages="
                        errors !== undefined ? errors.expire : ''
                      "
                      type="number"
                      label="تاریخ انقضا(روز)"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                      v-model="service"
                      :rules="rules.service"
                      :items="services"
                      item-text="nameLand"
                      item-value="id"
                      label="انتخاب سرویس"
                      :error-messages="
                        errors !== undefined ? errors.service_id : ''
                      "
                      outlined
                      multiple
                      dense
                      return-object
                    ></v-select>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-select
                      v-model="show"
                      :items="shows"
                      item-text="name"
                      item-value="id"
                      :error-messages="errors !== undefined ? errors.show : ''"
                      label="وضعیت نمایش"
                      outlined
                      dense
                      return-object
                    ></v-select>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="sortOrder"
                      :rules="rules.sortOrder"
                      label="ترتیب نمایش"
                      :error-messages="
                        errors !== undefined ? errors.sort_order : ''
                      "
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                      v-model="roleid"
                      :rules="rules.status"
                      :items="roles"
                      item-text="name_fa"
                      item-value="id"
                      :error-messages="
                        errors !== undefined ? errors.role_id : ''
                      "
                      label="انتخاب نقش"
                      outlined
                      dense
                      return-object
                    ></v-select>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-row class="justify-content-center mb-2">
                    <v-chip color="accent">
                      <v-icon>mdi-message</v-icon>
                      پیامک
                    </v-chip>
                  </v-row>
                </v-row>

                <!--                تعرفه های پیامک لند-->
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <sub-line-picker v-model="subline"></sub-line-picker>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <smsTariffPicker v-model="tariff"></smsTariffPicker>
                  </v-flex>
                </v-row>

                <!--                تعرفه های ربات لند-->

                <v-row class="justify-content-center mb-2">
                  <v-chip color="success">
                    <v-icon>mdi-robot</v-icon>
                    ربات آگهی
                  </v-chip>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <label>تعرفه شماره</label>
                    <v-overflow-btn
                      label="شماره"
                      id="residenceProvince"
                      editable
                      dense
                      auto-select-first
                      outlined
                      v-model="rb.rb.number"
                      :items="rbNumbers"
                    />
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <label>تعرفه چت</label>
                    <v-overflow-btn
                      label="چت"
                      id="residenceProvince"
                      editable
                      dense
                      auto-select-first
                      outlined
                      v-model="rb.rb.chat"
                      :items="rbChat"
                    />
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <label>تعرفه شماره یکتا</label>
                    <v-overflow-btn
                      label="شماره یکتا"
                      id="residenceProvince"
                      editable
                      dense
                      auto-select-first
                      outlined
                      v-model="rb.rb.unique"
                      :items="rbUnique"
                    />
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <label>تعرفه شماره جدید</label>
                    <v-overflow-btn
                      label="شماره جدید"
                      id="residenceProvince"
                      editable
                      dense
                      auto-select-first
                      outlined
                      v-model="rb.rb.new"
                      :items="rbNew"
                    />
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <label>تعرفه گزارش</label>
                    <v-overflow-btn
                      label="گزارش"
                      id="residenceProvince"
                      editable
                      dense
                      auto-select-first
                      outlined
                      v-model="rb.rb.report"
                      :items="rbReports"
                    />
                  </v-flex>
                </v-row>

                <!--                تعرفه های عاملیت-->

                <v-row class="justify-content-center mb-2">
                  <v-chip color="warning">
                    <v-icon>mdi-domain</v-icon>
                    عاملیت
                  </v-chip>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      label="درصد سود شارژ کیف پول"
                      dense
                      outlined
                      append-icon="mdi-percent"
                      :rules="rules.percent"
                      @keypress="isNumberKey"
                      maxlength="3"
                      v-model="profitPercent"
                    />
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <price-input
                      :dense="true"
                      :label="'مبلغ سود ثبت نامی جدید'"
                      :error="errors !== undefined ? errors.price : ''"
                      v-model="profitSignup"
                    ></price-input>
                  </v-flex>
                </v-row>

                <v-row class="justify-content-center mb-2">
                  <v-chip color="error" @click="dialogWallet = true">
                    <v-icon>mdi-account-cash</v-icon>
                    کارمزد
                  </v-chip>
                </v-row>

                <v-row class="justify-content-center mt-7">
                  <v-card-title>ویژگی ها</v-card-title>
                </v-row>

                <v-row v-for="(item, i) in features" :key="i">
                  <v-flex xs6 sm6 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="item.key"
                      label="نوع ویژگی"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs6 sm6 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="item.value"
                      label="مقدار ویژگی"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex class="xs12 sm12 md12 lg12 xl12 p-2'">
                    <v-btn class="btn-add-with-text" block @click="addCount">
                      <v-icon>mdi-plus</v-icon>
                      افزودن تعداد ویژگی
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-btn
                      color="btn-dec-with-text"
                      block
                      @click="decreaseCount"
                    >
                      <span class="fa fa-minus icon-lg"></span>
                      کاهش تعداد ویژگی
                    </v-btn>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex class="p-2">
                    <v-textarea
                      v-model="description"
                      label="توضیحات"
                    ></v-textarea>
                    <!--                                        <ckeditor :editor="editor.editor" v-model="description"-->
                    <!--                                                  :config="editor.editorConfig">-->

                    <!--                                        </ckeditor>-->
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <custom-popup v-model="dialogWallet" :cons="editCons" hide-overlay>
          <template v-slot:extension></template>
          <v-row>
            <v-flex xs12 sm12 md12 lg12 xl12 class="p-10">
              <v-card elevation="0" color="transparent" class="p-4">
                <v-card outlined class="mb-2">
                  <v-row>
                    <v-flex xs12 sm12 md12 lg12 xl12 class="p-8">
                      <label>انتخاب محصول</label>
                      <v-overflow-btn
                        append-icon="mdi-menu"
                        editable
                        auto-select-first
                        outlined
                        multiple
                        item-value="_id"
                        item-text="description"
                        v-model="productsList"
                        :items="products"
                        @change="overflowChange($event)"
                      />
                    </v-flex>
                  </v-row>

                  <v-row
                    align="center"
                    class="ma-0 pt-3"
                    v-for="(x, i) in wageData"
                    :key="i"
                  >
                    <v-col cols="6" lg="6" class="pt-0">
                      <v-chip>{{
                        x.name + " \t" + "( " + x.description + " )"
                      }}</v-chip>
                    </v-col>

                    <v-col cols="3" lg="3" class="pt-0">
                      <v-text-field
                        label="درصد"
                        v-model="x.wagePercent"
                        outlined
                        id="propKey"
                      />
                    </v-col>
                    <v-col cols="3" lg="3" class="pt-0">
                      <price-input
                        label="مبلغ"
                        v-model="x.wagePrice"
                        outlined
                        id="propValue"
                      />
                    </v-col>
                  </v-row>
                </v-card>

                <v-divider />
              </v-card>
            </v-flex>
          </v-row>
        </custom-popup>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SET_BREADCRUMB } from "../../../../core/services/store/breadcrumbs.module";
import subLinePicker from "@/view/pages/pickers/subLinePicker";
import permissionPicker from "@/view/pages/pickers/permissionPicker";
import priceInput from "@/view/pages/pickers/priceInput";
import smsTariffPicker from "@/view/pages/pickers/smsTariffPicker";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";

export default {
  props: ["id"],
  components: { permissionPicker, priceInput, subLinePicker, smsTariffPicker },
  data() {
    return {
      dialogWallet: false,
      editCons: {
        title: "درصد کارمزد پنل",
        buttons: [{ text: "", type: "submit", handler: this.submitWage }],
      },
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      service: [],
      loading: false,
      services: [],
      productsList: [],
      profitPercent: 0,
      profitSignup: 0,
      rbNumbers: [],
      rbChat: [],
      rbUnique: [],
      rbReports: [],
      rbNew: [],
      wageData: [],
      products: [],
      title: null,
      price: 0,
      expire: null,
      permissions: {},
      roleid: null,
      tariff: {},
      rb: {
        rb: {
          number: null,
          chat: null,
          new: null,
          unique: null,
          report: null,
        },
      },
      subline: {},
      tariffs: [],
      owner: { id: null },
      show: { id: null },
      shows: [
        { id: 1, name: "نمایش" },
        { id: 0, name: "عدم نمایش" },
      ],
      sortOrder: null,
      features: [],
      description: null,
      roles: [],
      url: "pack",
      errors: [],
      rules: {
        title: [
          (val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد.",
        ],
        percent: [
          (val) =>
            (val >= 0 && val <= 100) ||
            "درصد وارد شده باید بین ۰ تا ۱۰۰ باشد!.",
        ],
        services: [(val) => val.length > 0 || "فیلد سرویس الزامی می باشد."],
        price: [(val) => (val || "").length > 0 || "فیلد قیمت الزامی می باشد."],
        expire: [
          (val) => (val || "").length > 0 || "فیلد تاریخ انقضا الزامی می باشد.",
        ],
      },
    };
  },

  async mounted() {
    this.getPack();
    this.fetchProducts();
    this.fetchWage();
    this.getRoles();
    // this.getRbChat()
    // this.getRbReports()
    // this.getRbNumber()
    // this.getRbNew()
    // this.getRbUnique()
    try {
      this.services = await this.getService();
    } catch (error) {
      console.error("Failed to fetch services:", error);
      this.$toast.error("خطا در دریافت سرویس‌ها");
    } finally {
    }
    // this.services = this.getService().data;
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t(this.$route.meta.title) }]);
  },
  methods: {
    searchByKeyAndReturnValuePrice(array, key, value) {
      for (const obj of array) {
        if (obj[key] === value) {
          return obj?.wagePrice;
        }
      }
      return 0;
    },

    searchByKeyAndReturnValuePercent(array, key, value) {
      for (const obj of array) {
        if (obj[key] === value) {
          return obj?.wagePercent;
        }
      }
      return 0;
    },

    overflowChange(e) {
      this.wageData = this.products
        .filter((item) => e.includes(item._id))
        .map((item) => {
          return {
            panelId: Number(this.id),
            productId: item._id,
            name: item.name,
            description: item.description,
            wagePercent: this.searchByKeyAndReturnValuePercent(
              this.wageData,
              "productId",
              item._id
            ),
            wagePrice: this.searchByKeyAndReturnValuePrice(
              this.wageData,
              "productId",
              item._id
            )
              .toString()
              .replace(/,/g, ""),
          };
        });
    },
    newKeyValue() {
      this.wageData.push({
        panelId: Number(this.id),
        productId: "",
        wagePercent: 0,
        wagePrice: 0,
      });
    },
    deleteKeyValue(x, i) {
      if (confirm("کارمزد حذف شود ؟")) {
        this.wageData.splice(this.wageData.indexOf(i), 1);
      }
    },

    fetchWage() {
      this.loading = true;
      this.requestApiGetWallet(`wage/${this.id}`)
        .then((response) => {
          let wage = [];
          let checkedWages = [];
          for (let i = 0; i < response.data.data.length; i++) {
            checkedWages.push(response.data.data[i].productId._id);
            wage.push({
              panelId: Number(this.id),
              productId: response.data.data[i].productId._id,
              name: response.data.data[i].productId.name,
              description: response.data.data[i].productId.description,
              wagePercent: response.data.data[i].wagePercent,
              wagePrice: response.data.data[i].wagePrice,
            });
          }
          this.wageData = wage;
          this.productsList = checkedWages;
          // var item=this.products.filter(item => e.includes(item._id))
          // console.log(item[index].name)

          this.loading = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات چت ربات لند");
        });
    },
    fetchProducts() {
      this.loading = true;
      this.requestApiGetWallet(`product`)
        .then(({ data }) => {
          let products = [];
          // for (let i = 0; i < data.data.length; i++) {
          // products.push({
          //     text: data.data[i].name + ' \t' + '( ' + data.data.data[i].description + ' )',
          //     value: data.data[i]._id
          // })
          // }
          this.products = data.data;
          this.loading = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات محصول از کیف پول");
        });
    },
    submitWage() {
      this.requestApiPostWallet("wage", { data: this.wageData })
        .then(({ data }) => {
          this.loading = false;
          this.$toast.success("اعمال کارمزد با موفقیت انجام شد");
          this.fetchWage();
          this.dialog = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در انجام عملیات");
          this.loading = false;
        });
    },
    getRbChat() {
      this.loading = true;
      this.requestApiGetRb(`admin/packs/other/type/chat`)
        .then((response) => {
          let category = [];
          for (let i = 0; i < response.data.data.length; i++) {
            category.push({
              text:
                response.data.data[i].title +
                " \t" +
                "( " +
                response.data.data[i].price +
                " )",
              value: response.data.data[i].id,
            });
          }
          this.rbChat = category;
          this.loading = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات چت ربات لند");
        });
    },

    getRbReports() {
      this.loading = true;
      this.requestApiGetRb(`admin/packs/other/type/report`)
        .then((response) => {
          let category = [];
          for (let i = 0; i < response.data.data.length; i++) {
            category.push({
              text:
                response.data.data[i].title +
                " \t" +
                "( " +
                response.data.data[i].price +
                " )",
              value: response.data.data[i].id,
            });
          }
          this.rbReports = category;
          this.loading = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات گزارش ربات لند");
        });
    },

    getRbUnique() {
      this.loading = true;
      this.requestApiGetRb(`admin/packs/other/type/unique`)
        .then((response) => {
          let category = [];
          for (let i = 0; i < response.data.data.length; i++) {
            category.push({
              text:
                response.data.data[i].title +
                " \t" +
                "( " +
                response.data.data[i].price +
                " )",
              value: response.data.data[i].id,
            });
          }
          this.rbUnique = category;
          this.loading = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات شماره یکتا ربات لند");
        });
    },
    getRbNumber() {
      this.requestApiGetRb(`admin/packs/numbers/all`)
        .then((response) => {
          let category = [];
          for (let i = 0; i < response.data.data.length; i++) {
            category.push({
              text:
                response.data.data[i].title +
                " \t" +
                "( " +
                response.data.data[i].price +
                " )",
              value: response.data.data[i].id,
            });
          }
          this.rbNumbers = category;
          this.loading = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات شماره ربات لند");
        });
      this.loading = true;
    },

    getRbNew() {
      this.loading = true;
      this.requestApiGetRb(`admin/packs/other/type/new`)
        .then((response) => {
          let category = [];
          for (let i = 0; i < response.data.data.length; i++) {
            category.push({
              text:
                response.data.data[i].title +
                " \t" +
                "( " +
                response.data.data[i].price +
                " )",
              value: response.data.data[i].id,
            });
          }
          this.rbNew = category;
          this.loading = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات شماره جدید لند");
        });
    },

    addCount() {
      this.features.push({
        id: this.features.length + 1,
        key: null,
        value: null,
      });
    },
    decreaseCount() {
      if (this.features.length > 0) {
        this.features.pop();
      }
    },
    getRoles() {
      this.requestApiGet("admin/roles", { length: 1000 }).then((response) => {
        this.roles = response.data.data;
      });
    },

    getPack() {
      this.requestApiGet(`${this.url}/${this.id}`).then(({ data }) => {
        this.service = data.service;
        this.title = data.title;
        this.price = data.price + "";
        this.expire = data.expire;
        this.tariff = data.pack_id;
        this.show = data.show;
        this.description = data.description;
        this.roleid = data.role_id;
        this.subline = data.subline_id;
        this.features = data.features;
        this.role = data.role_id;
        this.sortOrder = data.sort_order;
        this.rb.rb.chat = data.rb.chat;
        this.rb.rb.number = data.rb.number;
        this.rb.rb.new = data.rb.new;
        this.rb.rb.report = data.rb.report;
        this.rb.rb.unique = data.rb.unique;
        this.profitPercent = data.profit_percent;
        this.profitSignup = data.signUp_profit;
      });
    },
    updatePack() {
      if (this.price < 0) {
        this.$toast.error("مبلغ باید بیشتر از ۰ باشد!");
      }

      let role_data = null;
      if (this.roleid) {
        role_data = this.roleid.id;
      } else {
        this.$toast.error("وارد کردن نقش الزامیست");
      }

      let data = {};
      console.log(
        "this.tariff && this.subline && role_data",
        this.tariff,
        this.subline,
        this.roleid
      );

      if (this.tariff && this.subline && role_data) {
        data = {
          title: this.title,
          price: this.price.toString().replace(/,/g, ""),
          signUp_profit: this.profitSignup.toString().replace(/,/g, ""),
          profit_percent: this.profitPercent,
          expire: this.expire,
          tariff_id: this.subline,
          pack_id: this.tariff,
          rb: this.rb.rb,
          show: this.show.id,
          features: this.features,
          description: this.description,
          service_id: this.service.map((item) => item.id),
          role_id: role_data,
          _method: "PUT",
        };
      } else {
        data = {
          title: this.title,
          pack_id: this.tariff,
          price: this.price.toString().replace(/,/g, ""),
          signUp_profit: this.profitSignup.toString().replace(/,/g, ""),
          profit_percent: this.profitPercent,
          expire: this.expire,
          rb: this.rb.rb,
          show: this.show.id,
          features: this.features,
          description: this.description,
          service_id: this.service.map((item) => item.id),
          role_id: role_data,
          _method: "PUT",
        };

        // this.$modal.yesNo('تعرفه های پیامک لند','شما تعرفه های پیامک لند را انتخاب نکرده اید آیا ادامه میدهید؟',)
        //     .then(response => {
        //       if (response===true){
        //
        //       }
        //
        //     }).catch(({response}) => {
        // })
      }

      this.loading = true;

      this.requestApiPost(`${this.url}/${this.id}`, data)
        .then(({ data }) => {
          this.$toast.success("با موفقیت ویرایش شد.");
          this.$router.push({ name: "panels.index" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
        });
    },
  },
};
</script>
